import { useState, useCallback } from 'react'

/**
 * 通知系统 Hook
 */
export const useNotifications = () => {
  const [notifications, setNotifications] = useState([])

  const removeNotification = useCallback((id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id))
  }, [])

  const addNotification = useCallback((notification) => {
    const id = Date.now() + Math.random()
    const newNotification = {
      id,
      ...notification,
      timestamp: Date.now(),
    }
    setNotifications((prev) => [...prev, newNotification])

    // 自动移除通知
    if (notification.duration) {
      setTimeout(() => {
        removeNotification(id)
      }, notification.duration)
    }
  }, [removeNotification])

  return {
    notifications,
    addNotification,
    removeNotification,
  }
}
